import moment from "moment-timezone";

const correctTimezone = (date = null) =>
  date ? moment.utc(date).tz("America/Sao_Paulo").format() : date;


export const dataDiff = (lastCharge) =>{
  const now = moment(new Date()); // Data de hoje
  const past = moment(lastCharge); // Outra data no passado
  const duration = moment.duration(now.diff(past));
  const days = duration.asDays();
  
  return parseInt(days)
}
/**
 * It's return DD/MM/YYYY
 */
export const getFormattedDate = (date) => {
  if (!date) return;
  date = date.replace(" ", "T");
  date = correctTimezone(date);
  const FormattedDate = new Date(date);
  let day = FormattedDate.getDate();
  day = day < 10 ? "0" + day : day;
  // getMonth() return (0 - 11)
  let month = FormattedDate.getMonth() + 1;
  month = month < 10 ? "0" + month : month;
  return day + "/" + month + "/" + FormattedDate.getFullYear();
};

/**
 * It's return DD/MM/YYYY
 */
export const getFormattedTime = (date) => {
  if (!date) return;
  date = date.replace(" ", "T");
  date = correctTimezone(date);
  const FormattedDate = new Date(date);
  let hh = FormattedDate.getHours();
  hh = hh < 10 ? "0" + hh : hh;
  // getMonth() return (0 - 11)
  let mm = FormattedDate.getMinutes() + 1;
  mm = mm < 10 ? "0" + mm : mm;
  let ss = FormattedDate.getSeconds() + 1;
  ss = ss < 10 ? "0" + ss : ss;
  return hh + ":" + mm + ":" + ss;
};

export const checkIsToday = (date) => {
  if (!date) return;
  const today = new Date();
  date = date.replace(" ", "T");
  const dateToCanpare = new Date(date);
  const isToday =
    today.getUTCFullYear() === dateToCanpare.getUTCFullYear() &&
    today.getUTCMonth() === dateToCanpare.getUTCMonth() &&
    today.getUTCDate() === dateToCanpare.getUTCDate();
  return isToday;
};

export const checkIsOlderThanLast4Hours = (date) => {
  if (!date) return;
  const today = new Date();
  date = date.replace(" ", "T");
  const dateToCanpare = new Date(date);
  const isToday =
    today.getUTCFullYear() === dateToCanpare.getUTCFullYear() &&
    today.getUTCMonth() === dateToCanpare.getUTCMonth() &&
    today.getUTCDate() === dateToCanpare.getUTCDate() &&
    today.getUTCHours() - dateToCanpare.getUTCHours() < 4;
  return isToday;
};
